<div>
    <ion-row [ngClass]="{
        'timer': !timerStarted,
        'timer-blue': timerStarted
    }" (click)="recordAthTime()">
        <ion-col text-center style="padding-top: 0;">
            <strong [style.color]="color">
                <p class="font-size-verylarge">{{displayTimer()}}</p>
            </strong>
            <p *ngIf="timerStarted">Click to record time</p>
        </ion-col>
    </ion-row>
    <ion-row class="track-buttons-container">
        <div class="track-buttons">
            <ion-col>
                <button ion-button (click)="openScoreboardByName()" icon-only clear>
                    <ion-icon name="list"></ion-icon>
                </button>
            </ion-col>
            <ion-col>
                <button *ngIf="!timerStarted"[style.backgroundColor]="color" ion-button icon-only clear (click)="startTimer()">
                    <ion-icon name="play" [style.color]="bgColor" class="font-medium center-triangle"></ion-icon>
                </button>
                <button *ngIf="timerStarted"[style.backgroundColor]="color" ion-button class="round scale-big colored round-big" icon-only clear (click)="pauseTimer()">
                    <ion-icon name="pause" [style.color]="bgColor" class="font-medium"></ion-icon>
                </button>
            </ion-col>
            <ion-col>
                <button ion-button icon-only clear (click)="restartTimer()">
                    <ion-icon [style.color]="colorIcon" name="ios-refresh-circle-outline"></ion-icon>
                </button>
            </ion-col>
        </div>
    </ion-row>
    <ion-row class="athletes">
        <ion-row class="scoreboard-header">
            <ion-col class="scoreboard-header-place">Place</ion-col>
            <ion-col class="scoreboard-header-name">Name</ion-col>
            <ion-col class="scoreboard-header-bib">bibNo</ion-col>
            <ion-col class="scoreboard-header-time">Time</ion-col>
        </ion-row>
        <div class="athletes-container" #scrollMe [scrollTop]="scrollMe.scrollHeight">
            <ion-row class="athletes" >
                <div class="athlete" *ngFor="let athlete of athletes" (click)="enterUserName(athlete)">
                    <p class="athlete-place">{{athlete.place}}</p> <p [ngClass]="{'athlete-name-grey': athlete.isSelected, 
                                                       'athlete-name-white': !athlete.isSelected}">{{athlete.name}}</p><p class="athlete-bibNo">{{athlete.bibNo}}</p><p><span class="athlete-time">{{athlete.time}}</span></p>
                </div>
            </ion-row>
        </div>
    </ion-row>
    <ion-row class="bottom-numpud-container">
        <div class="bottom-numpud">
            <button ion-button [ngClass]="{
                'letter-button-lowercase': !shiftPressed,
                'letter-button-uppercase': shiftPressed}" (click)="enterLetter('q')">q</button>
            <button ion-button [ngClass]="{
                'letter-button-lowercase': !shiftPressed,
                'letter-button-uppercase': shiftPressed}" (click)="enterLetter('w')">w</button>
            <button ion-button [ngClass]="{
                'letter-button-lowercase': !shiftPressed,
                'letter-button-uppercase': shiftPressed}" (click)="enterLetter('e')">e</button>
            <button ion-button [ngClass]="{
                'letter-button-lowercase': !shiftPressed,
                'letter-button-uppercase': shiftPressed}" (click)="enterLetter('r')">r</button>
            <button ion-button [ngClass]="{
                'letter-button-lowercase': !shiftPressed,
                'letter-button-uppercase': shiftPressed}" (click)="enterLetter('t')">t</button>
            <button ion-button [ngClass]="{
                'letter-button-lowercase': !shiftPressed,
                'letter-button-uppercase': shiftPressed}" (click)="enterLetter('y')">y</button>
            <button ion-button [ngClass]="{
                'letter-button-lowercase': !shiftPressed,
                'letter-button-uppercase': shiftPressed}" (click)="enterLetter('u')">u</button>
            <button ion-button [ngClass]="{
                'letter-button-lowercase': !shiftPressed,
                'letter-button-uppercase': shiftPressed}" (click)="enterLetter('i')">i</button>
            <button ion-button [ngClass]="{
                'letter-button-lowercase': !shiftPressed,
                'letter-button-uppercase': shiftPressed}" (click)="enterLetter('o')">o</button>
            <button ion-button [ngClass]="{
                'letter-button-lowercase': !shiftPressed,
                'letter-button-uppercase': shiftPressed}" (click)="enterLetter('p')">p</button>
            <button ion-button [ngClass]="{
                'letter-button-lowercase': !shiftPressed,
                'letter-button-uppercase': shiftPressed}" class="a-letter" (click)="enterLetter('a')">a</button>
            <button ion-button [ngClass]="{
                'letter-button-lowercase': !shiftPressed,
                'letter-button-uppercase': shiftPressed}" (click)="enterLetter('s')">s</button>
            <button ion-button [ngClass]="{
                'letter-button-lowercase': !shiftPressed,
                'letter-button-uppercase': shiftPressed}" (click)="enterLetter('d')">d</button>
            <button ion-button [ngClass]="{
                'letter-button-lowercase': !shiftPressed,
                'letter-button-uppercase': shiftPressed}" (click)="enterLetter('f')">f</button>
            <button ion-button [ngClass]="{
                'letter-button-lowercase': !shiftPressed,
                'letter-button-uppercase': shiftPressed}" (click)="enterLetter('g')">g</button>
            <button ion-button [ngClass]="{
                'letter-button-lowercase': !shiftPressed,
                'letter-button-uppercase': shiftPressed}" (click)="enterLetter('h')">h</button>
            <button ion-button [ngClass]="{
                'letter-button-lowercase': !shiftPressed,
                'letter-button-uppercase': shiftPressed}" (click)="enterLetter('j')">j</button>
            <button ion-button [ngClass]="{
                'letter-button-lowercase': !shiftPressed,
                'letter-button-uppercase': shiftPressed}" (click)="enterLetter('k')">k</button>
            <button ion-button [ngClass]="{
                'l-letter-lowercase': !shiftPressed,
                'l-letter-uppercase': shiftPressed}" (click)="enterLetter('l')">l</button>
            <button ion-button class="shift-button" (click)="pressShift()"
                    [ngClass]="{'shift-button-grey': shiftPressed, 'shift-button-blue': !shiftPressed}"><ion-icon name="arrow-up"></ion-icon>
            </button>
            <button ion-button [ngClass]="{
                'letter-button-lowercase': !shiftPressed,
                'letter-button-uppercase': shiftPressed}" (click)="enterLetter('z')">z</button>
            <button ion-button [ngClass]="{
                'letter-button-lowercase': !shiftPressed,
                'letter-button-uppercase': shiftPressed}" (click)="enterLetter('x')">x</button>
            <button ion-button [ngClass]="{
                'letter-button-lowercase': !shiftPressed,
                'letter-button-uppercase': shiftPressed}" (click)="enterLetter('c')">c</button>
            <button ion-button [ngClass]="{
                'letter-button-lowercase': !shiftPressed,
                'letter-button-uppercase': shiftPressed}" (click)="enterLetter('v')">v</button>
            <button ion-button [ngClass]="{
                'letter-button-lowercase': !shiftPressed,
                'letter-button-uppercase': shiftPressed}" (click)="enterLetter('b')">b</button>
            <button ion-button [ngClass]="{
                'letter-button-lowercase': !shiftPressed,
                'letter-button-uppercase': shiftPressed}" (click)="enterLetter('n')">n</button>
            <button ion-button [ngClass]="{
                'letter-button-lowercase': !shiftPressed,
                'letter-button-uppercase': shiftPressed}" (click)="enterLetter('m')">m</button>
            <button ion-button class="delete-button" (click)="deleteLetter()"><ion-icon name="backspace"></ion-icon></button>
            <button ion-button >123</button>
            <button ion-button class="space-button" (click)="spaceButton()"></button>
            <button ion-button class="enter-button" (click)="enterNumPud()">Enter</button>
        </div>
    </ion-row>
</div>